import {sendBeacon} from './navigator';

export function beaconTransport(url) {
  return new Promise((resolve, reject) =>
    sendBeacon(url) ? resolve() : reject(new Error('Transport Error: Cannot send bi using beacons')));
}

export function pixelTransport(url, image) {
  return new Promise((resolve, reject) => {
    const biImage = image || new window.Image(0, 0);
    biImage.onload = () => resolve();
    biImage.onerror = () => reject(new Error('Transport Error: Cannot send bi using pixelTransport'));
    biImage.src = url;
  });
}

export function fetchTransport(url) {
  return fetch(url, {credentials: 'include'})
    .then(response => {
      if (!response.ok) {
        throw Error(`Transport Error: Cannot send bi using fetch. Status: ${response.status}`);
      }
    });
}



// WEBPACK FOOTER //
// ./lib/transport.js